export const userIsMemberOfCurrentGroup = (user, community) => {
  if (!user) return false;
  const userGroups = user.followedCommunities || [];
  const userGroupIds = userGroups.map(grp => grp.communityId);
  return userGroupIds.indexOf(community.communityId) !== -1;
};

export const userHasRole = (user, role) => {
  if (!user) return false;
  const roles = user.roles || [];
  return roles.indexOf(role) !== -1;
};

export const userHasPermission = (user, permission) => {
  if (!user) return false;
  const permissions = user.permissions || [];
  return permissions.indexOf(permission) !== -1;
};



// WEBPACK FOOTER //
// ./src/utils/context.js